module.exports = __webpack_public_path__ + "media/entities/1118-18d9ac28.png";